// The text colour that reads best on a background colour: dark on light colours (a yellow), white on dark ones.
export const readableInk = (background, dark = '#1b2230', light = '#ffffff') => {
  const hex = String(background || '').trim().replace('#', '');
  const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
  if (!/^[0-9a-f]{6}$/i.test(full)) return light;
  const [r, g, b] = [0, 2, 4].map((i) => {
    const channel = parseInt(full.slice(i, i + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  // only the genuinely light colours (yellow, light green) get dark text; the mid and dark ones keep the white the widget uses
  return luminance > 0.3 ? dark : light;
};
